__turbopack_context__.v({
  "className": "ibm_plex_mono_14a87518-module__Cf_Z-W__className",
});
